import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';

@Injectable({
  providedIn: 'root'
})
export class DomainService {
  
  private static apiUrlSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public static apiUrl$ = DomainService.apiUrlSubject.asObservable();

  static backurl: string;

  constructor(private http: HttpClient) {
    this.loadApiUrl();
  }

  private loadApiUrl() {
    debugger;
    this.http.get<any>('assets/tempdata.json').subscribe(data => {
      const apiUrl = data.enmBackend.apiUrl;
      DomainService.backurl = apiUrl;
      DomainService.apiUrlSubject.next(apiUrl);
      localStorage.setItem('apiUrl', apiUrl);
    });
  }

  public static getApiUrl(): Promise<string> {
    return new Promise((resolve) => {
      if (this.backurl) {
        resolve(this.backurl);
      } else {
        const storedApiUrl = localStorage.getItem('apiUrl');
        if (storedApiUrl) {
          resolve(storedApiUrl);
        } else {
          DomainService.apiUrl$.subscribe(apiUrlValue => {
            if (apiUrlValue) {
              resolve(apiUrlValue);
            }
          });
        }
      }
    });
  }

  public getData(type: string): Observable<any> {
    return this.http.get<any>('assets/tempdata.json').pipe(map((res: any) => res[type]));
  }
}
